import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { CreateTransaction } from 'app/dtos/Transaction/createTransaction';
import { CreateTransactionProduct } from 'app/dtos/Transaction/createTransactionProduct';
import { _isId } from 'app/services/auth.service';
import { ExpenseService } from 'app/services/models/expense.service';
import { ProjectService } from 'app/services/models/project.service';
import { TaxService } from 'app/services/models/tax.service';
import { TransactionService } from 'app/services/models/transaction.service';
import { VaultService } from 'app/services/models/vault.service';
import { Turkish } from 'flatpickr/dist/l10n/tr';
import { FlatpickrOptions } from 'ng2-flatpickr';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-expense-transaction-create',
  templateUrl: './expense-transaction-create.component.html',
  styleUrls: ['./expense-transaction-create.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ExpenseTransactionCreateComponent implements OnInit {
  public contentHeader;
  expenseTransactionForm: FormGroup

  date = new Date();
  public basicDateOptions: FlatpickrOptions = {
    altInput: true,
    locale: Turkish,
  }

  expenses: any[] = [];
  projects: any[] = [];
  taxes: any[] = [];
  vaults: any[] = [];
  constructor(
    private formBuilder: FormBuilder,
    private projectService: ProjectService,
    private taxexService: TaxService,
    private expenseService: ExpenseService,
    private transactionService: TransactionService,
    private toastService: ToastrService,
    private router: Router,
    private vaultService: VaultService,) {
    this.expenseTransactionForm = this.formBuilder.group({
      project: [null],
      expense: [null, [Validators.required]],
      transactionDate: [this.date, [Validators.required]],
      documentNo: [null, [Validators.maxLength(16)]],
      totalAmount: [null, Validators.required],
      taxRate: [null, Validators.required],
      description: [null],
      vaultId: [null, [Validators.required]]
    });
  }


  searchFn(term: string, item: any) {
    // Make the search term case-insensitive
    // Make the search term case-insensitive and handle Turkish characters
    term = term.toLocaleLowerCase('tr-TR');

    // Check if the term matches either 'mainExpenseName' or 'name'
    const mainExpenseName = item.mainExpenseName?.toLocaleLowerCase('tr-TR') || '';
    const name = item.name?.toLocaleLowerCase('tr-TR') || '';

    return mainExpenseName.includes(term) || name.includes(term);
  }

  async ngOnInit() {
    this.contentHeader = {
      headerTitle: 'Masraflar',
      actionButton: true,
      breadcrumb: {
        type: '',
        links: [
          {
            name: 'Masraf Listesi',
            isLink: true,
            link: '/admin/mexpensetransaction'
          },
          {
            name: 'Masraf Ekle',
            isLink: false,
          },
        ]
      }
    }
    await this.getAllProject();
    await this.getAllKdv();
    await this.getAllExpense();

    await this.getAllVault();
  }

  async getAllVault() {
    const data = await this.vaultService.getAllVault(0, 100, '');
    console.log(data);
    this.vaults = data.vaults
  }


  async getAllProject() {
    const data = await this.projectService.getAllProject(0, 100, '');
    this.projects = data.projects.map(project => ({
      id: project.id,
      name: project.name
    }));
  }

  async getAllExpense() {
    const data = await this.expenseService.getExpense();
    console.log(data);
    this.expenses = data.map(expense => ({
      id: expense.id,
      name: expense.name,
      mainExpenseName: expense.mainExpenseName
    })
    );
  }

  async getAllKdv() {
    const data = await this.taxexService.getAllTax(0, 100, '');
    this.taxes = data.taxex.map(tax => ({
      id: tax.id,
      taxRate: `${tax.taxRate}%`
    }));
  }

  async onSubmit() {
    if (this.expenseTransactionForm.valid) {
      console.log(this.expenseTransactionForm.value);
      const createTransaction = new CreateTransaction();
      createTransaction.companyId = 2;
      createTransaction.projectId = this.expenseTransactionForm.value.project;
      createTransaction.expenseId = this.expenseTransactionForm.value.expense;
      createTransaction.startDate = new Date(this.expenseTransactionForm.value.transactionDate);
      createTransaction.docNo = this.expenseTransactionForm.value.documentNo;
      createTransaction.kindId = 5;
      createTransaction.userId = _isId,
        createTransaction.transactionPrivateNode = this.expenseTransactionForm.value.description
      const transactionProduct = new CreateTransactionProduct();
      transactionProduct.productId = 1;
      transactionProduct.currencyId = 1;
      transactionProduct.discountRate = 0;
      transactionProduct.productCount = 1;
      transactionProduct.productPrice = this.expenseTransactionForm.value.totalAmount;
      transactionProduct.taxId = this.expenseTransactionForm.value.taxRate;
      transactionProduct.warehouseId = 4;
      // `createTransactionProducts` dizisini bir dizi olarak ayarlayın
      createTransaction.createTransactionProducts = [transactionProduct];

      const response = await this.transactionService.createOffer(createTransaction);
      if (response.status) {
        this.router.navigate(['/admin/mexpensetransaction'])
        this.toastService.success(response.message);
        await this.vaultService.createCompanyVaultMovement(
          this.expenseTransactionForm.value.vaultId,
          transactionProduct.productPrice,
          15,
          _isId,
          1,
          `${createTransaction.docNo ?? null + createTransaction.transactionPrivateNode ?? null}`,
          createTransaction.projectId)
      } else {
        this.toastService.error(response.message);
      }
    } else {
      console.error('Formda hata var!');
    }
  }
}